<template>
    <div class="withdrawalSettings">
       <div style="display:flex;align-items: center">
            <!-- <div class="withdrawalSettings-title">税费</div> -->
            <!-- <span style="margin-left: 12px;color: #409EFF">当前状态：{{ tax === 1? '不包税': '包税' }}</span> -->
            <div class="withdrawalSettings-title"></div>
            <span style="margin-left: 12px;color: #409EFF">当前状态：{{ tax === 1? '商户进件': '豆包结算' }}</span>
       </div>
        <div style="padding:12px 0;margin-bottom:60px;">
            <div style="margin-left:60px">
                <!-- <div class="withdrawalSettings-subtitle">税费说明</div>
                <div style="line-height: 24px;color:#999;font-size: 14px">
					 <p>包税：服务费扣点10%（包含抖音抽点）；</p>
					 <p>不包税：服务费阶梯抽点，总收益20万以下抽8%，20-50万抽7%，50万以上抽6%（均包含抖音抽点）。</p>
                </div> -->
                <div style="margin-top: 12px" class="withdrawalSettings-step">
                    <!-- <span style="line-height: 24px;color:#999;font-size: 14px">开启平台不包税流程：</span> -->
                    <span style="line-height: 24px;color:#999;font-size: 14px">开启商户进件流程：</span>
                    <p>1、注册抖音商户</p>
                    <i class="el-icon-right"></i>
                    <p>2、等待抖音审核通过</p>
                    <i class="el-icon-right"></i>
                    <p>3、联系客服开通</p>
                </div>
            </div>
        </div>
        <div class="withdrawalSettings-title">抖音商户</div>
        <div style="padding:12px 0;line-height: 24px;color:#999;font-size: 14px">
           <p>为了更好的服务新老客户，我们已上线抖音商户注册功能。用户需注册子商户后，才可使用商户提现功能，新功能包括：</p>
           <p>1、收益直接入账：商户需要开通微信、支付宝、2个平台，方可完成抖音商户注册。抖音商户开通后，用户可选择其中任一渠道进行付款。付款7天后系统自动分账，商户的收益将直接入账子商户，更方便快捷；</p>
           <p>2、无限额提现：商户每日可无限额提现，不再受平台交易限制。一个收款商户只允许一天在某一个渠道成功提现 5 次；</p>
        </div>
        <div class="withdrawalSettings-title">分账规则</div>
        <div style="padding:12px 0;line-height: 24px;color:#999;font-size: 14px">
           <p>场景一：讲师进件的抖音商户中有不支持微信支付的，则课程支持分销且收益自动分配到该抖音商户，多个则轮询分配。</p>
           <p>场景二：讲师进件的抖音商户都支持微信支付，则课程不支持分销且收益直接轮询分配到各抖音商户。</p>
        </div>
        <div>
            <el-button type="primary" @click="accountBind(item)" v-for="(item, index) in chantList" :key="index">抖音商户{{index ? index: ''}}</el-button>
        </div>
        <div style="margin-top: 12px">
            <el-button size="mini" :disabled="chantList.length >=3" @click="addChant">添加账户</el-button>
            <span style="font-size:12px;margin-left:12px">最多添加3个</span>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    data() {
        return {
            tax: '',
            chantList: []
        }
    },
    created() {
        this.getMerchantTax()
        this.getMerchantList()
    },
    methods: {
        ...mapActions('dataCenter', ['merchantTax', 'merchantList']),
        accountBind(item) {
            if(item.id) {
                this.$router.push(this.staticPath + 'widthawalBind/'+ item.id+ '/'+ item.status+ '/'+ item.status_type)
            } else {
                this.$router.push(this.staticPath + 'widthawalBind')
            }
            
        },
        async getMerchantTax() {
            let res = await this.merchantTax()
            this.tax = res.tax_status
        },
        async getMerchantList() {
            let res = await this.merchantList()
            this.chantList = res
        },
        addChant() {
            this.chantList.push({})
        }
    }
}
</script>
<style lang="less" scoped>
    .withdrawalSettings {
        .withdrawalSettings-title {
            position: relative;
            padding-left: 12px;
            font-size: 16px;
            font-weight: 600;
            &::before {
                content: "";
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: 0;
                height: 20px;
                width: 4px;
                background-color: #1989fa;
            }
        }
        .withdrawalSettings-subtitle {
            font-size: 14px;
            font-weight: 600;
        }
        .el-icon-right {
            font-size: 20px;
            margin: 0 12px;
        }
        .withdrawalSettings-step {
            display: flex;
            align-items: center;
            >p {
                color: #FFF;
                background-color: #409EFF;
                padding: 12px 20px;
                font-size: 14px;
                border-radius: 4px;
                line-height: 1;
            }
        }
    }
</style>